/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portfolio_Hero_All_Time_Return_LabelInputs */

const en_portfolio_hero_all_time_return_label = /** @type {(inputs: Portfolio_Hero_All_Time_Return_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`all time return`)
};

const de_portfolio_hero_all_time_return_label = /** @type {(inputs: Portfolio_Hero_All_Time_Return_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesamtrendite`)
};

const pt_br2_portfolio_hero_all_time_return_label = /** @type {(inputs: Portfolio_Hero_All_Time_Return_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`retorno de todo o período`)
};

const tr_portfolio_hero_all_time_return_label = /** @type {(inputs: Portfolio_Hero_All_Time_Return_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tüm zamanların getirisi`)
};

const zh_cn2_portfolio_hero_all_time_return_label = /** @type {(inputs: Portfolio_Hero_All_Time_Return_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`成立以来收益`)
};

const zh_hk2_portfolio_hero_all_time_return_label = /** @type {(inputs: Portfolio_Hero_All_Time_Return_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`歷來回報`)
};

const ko_kr2_portfolio_hero_all_time_return_label = /** @type {(inputs: Portfolio_Hero_All_Time_Return_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`전체 기간 수익률`)
};

const ru_ru2_portfolio_hero_all_time_return_label = /** @type {(inputs: Portfolio_Hero_All_Time_Return_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`доходность за всё время`)
};

const es_419_portfolio_hero_all_time_return_label = /** @type {(inputs: Portfolio_Hero_All_Time_Return_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`rendimiento histórico`)
};

/**
* | output |
* | --- |
* | "all time return" |
*
* @param {Portfolio_Hero_All_Time_Return_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const portfolio_hero_all_time_return_label = /** @type {((inputs?: Portfolio_Hero_All_Time_Return_LabelInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portfolio_Hero_All_Time_Return_LabelInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portfolio_hero_all_time_return_label(inputs)
	if (locale === "de") return de_portfolio_hero_all_time_return_label(inputs)
	if (locale === "pt-BR") return pt_br2_portfolio_hero_all_time_return_label(inputs)
	if (locale === "tr") return tr_portfolio_hero_all_time_return_label(inputs)
	if (locale === "zh-CN") return zh_cn2_portfolio_hero_all_time_return_label(inputs)
	if (locale === "zh-HK") return zh_hk2_portfolio_hero_all_time_return_label(inputs)
	if (locale === "ko-KR") return ko_kr2_portfolio_hero_all_time_return_label(inputs)
	if (locale === "ru-RU") return ru_ru2_portfolio_hero_all_time_return_label(inputs)
	return es_419_portfolio_hero_all_time_return_label(inputs)
});